import React from 'react'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'

type Props = {
  children: number | string
  unit: string
}

export const NumberWithUnit: React.FC<Props> = (props) => {
  return (
    <span>
      <span
        css={css`
          color: ${colors.black30};
          font-size: 1.1rem;
        `}
      >
        {props.children}
      </span>
      <span
        css={css`
          font-size: 12px;
          color: ${colors.text};
          margin-left: 8px;
          font-weight: ${font.weight.normal};
        `}
      >
        {props.unit}
      </span>
    </span>
  )
}
